import React from "react";
import CourseLists from "./CourseLists";

class LeftCoursesLists extends React.Component {
    render() {
        return(
            <div>
                <CourseLists
                    listTitle={ "Major Courses" }
                    courses={ this.props.majorCoursesList }
                    height={ this.props.height }
                    changed={this.props.changed}
                />
            </div>
        );
    }
}

export default LeftCoursesLists;